import { Float, Text } from '@react-three/drei';

export function BlockStart({ position = [0, 0, 0] }) {
    return (
        <group position={position}>
            <Float floatIntensity={0.25} rotationIntensity={0.25}>
                <Text 
                    scale={0.4}
                    maxWidth={0.25}
                    lineHeight={0.75}
                    textAlign='left'
                    position={[-0.9, 1, 0]}
                    rotation={[-0.2, 0.3, 0.06]}
                    font='./bebas-neue-v9-latin-regular.woff'
                >
                    Marble Race
                    <meshBasicMaterial toneMapped={false} />
                </Text>
            </Float>
        </group>
    )
}